import { render, staticRenderFns } from "./CoursesWithoutBook.vue?vue&type=template&id=1ba47a0d&"
import script from "./CoursesWithoutBook.vue?vue&type=script&lang=js&"
export * from "./CoursesWithoutBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports